import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

// La ruta de guardar video exige esta cabecera en el backend (ver
// api/src/routes/leccionesVideo.js).
function cabeceras(usuario) {
  return { headers: { 'x-usuario-id': usuario?.id } }
}

export default function SalaVideos({ usuario }) {
  const [niveles,       setNiveles]       = useState([])
  const [nivelActivo,   setNivelActivo]   = useState(null)
  const [unidades,      setUnidades]      = useState([])
  const [unidadActiva,  setUnidadActiva]  = useState(null)
  const [lecciones,     setLecciones]     = useState([])
  const [leccionActiva, setLeccionActiva] = useState(null)
  const [form,          setForm]          = useState({ video_url: '', video_titulo: '', video_duracion: '' })
  const [guardando,     setGuardando]     = useState(false)
  const [mensaje,       setMensaje]       = useState(null)

  useEffect(() => {
    axios.get(API + '/curriculo/niveles').then(r => {
      setNiveles(r.data.datos || [])
      if (r.data.datos?.length > 0) setNivelActivo(r.data.datos[0])
    })
  }, [])

  useEffect(() => {
    if (!nivelActivo) return
    setUnidades([]); setUnidadActiva(null); setLecciones([]); setLeccionActiva(null)
    axios.get(API + '/curriculo/niveles/' + nivelActivo.id + '/unidades')
      .then(r => setUnidades(r.data.datos || []))
  }, [nivelActivo])

  useEffect(() => {
    if (!unidadActiva) return
    setLecciones([]); setLeccionActiva(null)
    axios.get(API + '/curriculo/unidades/' + unidadActiva.id + '/lecciones')
      .then(r => setLecciones(r.data.datos || []))
  }, [unidadActiva])

  useEffect(() => {
    if (!leccionActiva) return
    axios.get(API + '/curriculo/lecciones/' + leccionActiva.id)
      .then(r => {
        const l = r.data.datos
        setForm({
          video_url: l?.video_url || '',
          video_titulo: l?.video_titulo || '',
          video_duracion: l?.video_duracion || ''
        })
      })
  }, [leccionActiva])

  function mostrarMensaje(tipo, texto) {
    setMensaje({ tipo, texto })
    setTimeout(() => setMensaje(null), 4000)
  }

  async function guardarVideo() {
    if (!leccionActiva) return
    setGuardando(true)
    try {
      await axios.put(API + '/lecciones/' + leccionActiva.id + '/video', form, cabeceras(usuario))
      mostrarMensaje('ok', 'Video guardado correctamente')
    } catch (err) {
      mostrarMensaje('error', 'Error al guardar el video')
    }
    setGuardando(false)
  }

  const inputStyle = {
    width: '100%', padding: '9px 12px', border: '1.5px solid #E2E6F0',
    borderRadius: 8, fontFamily: 'inherit', fontSize: 13, outline: 'none',
    boxSizing: 'border-box', marginBottom: 12
  }
  const labelStyle = { fontSize: 12, fontWeight: 700, color: '#374151', marginBottom: 4, display: 'block' }
  const selectStyle = { ...inputStyle, cursor: 'pointer', marginBottom: 0 }

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 4px' }}>

      <div style={{ background: 'linear-gradient(135deg,#0D1F52,#1B3A8C)', borderRadius: 16, padding: 24, marginBottom: 24, color: '#fff' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontSize: 32 }}>🎬</span>
          <div>
            <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 2 }}>Videos de las lecciones</h1>
            <p style={{ fontSize: 13, opacity: .85 }}>Pega el link del video de repaso del profesor para cada lección. Puedes usar YouTube (no listado) o Google Drive.</p>
          </div>
        </div>
      </div>

      {mensaje && (
        <div style={{ padding: '12px 16px', borderRadius: 10, marginBottom: 16, fontSize: 14, fontWeight: 600,
          background: mensaje.tipo === 'ok' ? '#F0FDF4' : '#FEF2F2',
          color: mensaje.tipo === 'ok' ? '#166534' : '#991B1B',
          border: '1px solid ' + (mensaje.tipo === 'ok' ? '#22C55E' : '#EF4444') }}>
          {mensaje.tipo === 'ok' ? '✅' : '❌'} {mensaje.texto}
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 24 }}>
        <select style={selectStyle} value={nivelActivo?.id || ''} onChange={e => setNivelActivo(niveles.find(n => n.id === e.target.value))}>
          {niveles.map(n => <option key={n.id} value={n.id}>{n.nombre}</option>)}
        </select>
        <select style={selectStyle} value={unidadActiva?.id || ''} onChange={e => setUnidadActiva(unidades.find(u => u.id === e.target.value))}>
          <option value=''>Selecciona unidad</option>
          {unidades.map(u => <option key={u.id} value={u.id}>{u.titulo}</option>)}
        </select>
        <select style={selectStyle} value={leccionActiva?.id || ''} onChange={e => setLeccionActiva(lecciones.find(l => l.id === e.target.value))}>
          <option value=''>Selecciona leccion</option>
          {lecciones.map(l => <option key={l.id} value={l.id}>{l.titulo}</option>)}
        </select>
      </div>

      {!leccionActiva && (
        <div style={{ textAlign: 'center', padding: 60, color: '#6B7280', background: '#fff', borderRadius: 14, border: '1px solid #E2E6F0' }}>
          Selecciona un nivel, unidad y leccion arriba para agregar o editar su video.
        </div>
      )}

      {leccionActiva && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>

          <div style={{ background: '#fff', border: '1px solid #E2E6F0', borderRadius: 16, padding: 24 }}>
            <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 16 }}>{leccionActiva.titulo}</h3>

            <label style={labelStyle}>Link del video</label>
            <input style={inputStyle} value={form.video_url} onChange={e => setForm(f => ({ ...f, video_url: e.target.value }))}
              placeholder="https://www.youtube.com/embed/... o https://drive.google.com/file/d/XXX/preview" />

            <label style={labelStyle}>Titulo del video (opcional)</label>
            <input style={inputStyle} value={form.video_titulo} onChange={e => setForm(f => ({ ...f, video_titulo: e.target.value }))}
              placeholder="Ej: Review: Greetings and Introductions" />

            <label style={labelStyle}>Duracion (opcional)</label>
            <input style={inputStyle} value={form.video_duracion} onChange={e => setForm(f => ({ ...f, video_duracion: e.target.value }))}
              placeholder="Ej: 4:32" />

            <div style={{ background: '#F8FAFF', border: '1px solid #E2E6F0', borderRadius: 10, padding: 12, marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#1B3A8C', marginBottom: 6 }}>💡 Como conseguir el link correcto</div>
              <div style={{ fontSize: 12, color: '#6B7280', lineHeight: 1.6 }}>
                <strong>YouTube:</strong> sube el video como "No listado", dale click a Compartir → Insertar, y copia solo la URL de adentro del código (empieza con youtube.com/embed/...).<br />
                <strong>Google Drive:</strong> sube el video, click derecho → Compartir → "Cualquiera con el link", copia el link y cambia la palabra final <code>/view</code> por <code>/preview</code>.
              </div>
            </div>

            <button onClick={guardarVideo} disabled={guardando || !form.video_url}
              style={{ width: '100%', padding: '12px', background: (!form.video_url) ? '#E2E6F0' : '#1B3A8C', color: (!form.video_url) ? '#9CA3AF' : '#fff', border: 'none', borderRadius: 10, fontFamily: 'inherit', fontSize: 14, fontWeight: 700, cursor: (!form.video_url) ? 'not-allowed' : 'pointer' }}>
              {guardando ? 'Guardando...' : '✅ Guardar video'}
            </button>
          </div>

          <div style={{ background: '#fff', border: '1px solid #E2E6F0', borderRadius: 16, padding: 24 }}>
            <h3 style={{ fontSize: 13, fontWeight: 700, color: '#6B7280', marginBottom: 14, textTransform: 'uppercase' }}>Vista previa</h3>
            {form.video_url ? (
              <div style={{ background: '#000', borderRadius: 12, overflow: 'hidden', aspectRatio: '16/9' }}>
                <iframe
                  src={form.video_url}
                  title="Vista previa"
                  width="100%" height="100%"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ display: 'block' }}
                />
              </div>
            ) : (
              <div style={{ background: '#F4F6FA', borderRadius: 12, aspectRatio: '16/9', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9CA3AF', fontSize: 13 }}>
                Pega un link para ver la vista previa aqui
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
